import React from "react";
import AsaProfile from "../images/People/AsaHollandSquare.png";
import JeffProfile from "../images/People/jeff-hover-circular.png";
import MicheleProfile from "../images/People/michele_hover_profile.jpg";
import ShawnProfile from "../images/People/shawn_hover_profile.jpg";
import AlexProfile from "../images/People/AlexProfile.jpeg";
import JustinProfile from "../images/People/JustinProfile.jpeg";
import ThaliaProfile from "../images/People/ThaliaProfile.jpeg";
import PenelopeProfile from "../images/People/penelope_hover_profile.png";
import MiaProfile from "../images/People/miaProfile.jpg";
import TonyProfile from "../images/People/TonyProfile.jpg";

import "./AboutUsComponents.css";
// Info blurb component
interface SmallInfoBlurbsProps {
  header: string;
  content: string;
}

const SmallInfoBlurbs: React.FC<SmallInfoBlurbsProps> = ({
  header,
  content,
}) => {
  return (
    <div className="individual-info-container">
      <div className="individual-info-header">{header}</div>
      <div className="individual-info-content">{content}</div>
    </div>
  );
};

// About Us Header
export const AboutUsHeader = () => {
  return (
    <div className="about-us-header-div">
      <div className="about-us-header">Our Story</div>
      <div className="about-us-text">
        For over 25 years, <b>The Make a Memory Family</b> has been dedicated to
        helping teams, athletes, and organizations raise the funds they need to
        succeed. As a family-owned and family-run business, we know firsthand
        the challenges that come with fundraising—because we’ve been there
        ourselves. <br />
        <br />
        From former team moms and coaches to players who’ve lived the journey,
        our team understands the commitment and passion it takes to support
        young athletes. That’s why we’ve made it our mission to provide{" "}
        <b>easy, effective, and impactful fundraising solutions </b>that help
        teams reach their goals. <br />
        <br />
        With thousands of organizations served and millions of dollars raised,
        we take pride in being more than just a fundraising company—we’re a
        trusted partner in making dreams happen. <br />
        <br />
        Let’s build memories and success together!
      </div>
    </div>
  );
};

// Info Blurb Section
export const InfoBlurbSection = () => {
  return (
    <div className="info-blurb-division">
      <SmallInfoBlurbs header="25 years" content="years in business" />
      <SmallInfoBlurbs header="1000+" content="organizations helped" />
      <SmallInfoBlurbs header="$1,000,000+" content="money raised" />
    </div>
  );
};

// Foundational Principles Component
interface FoundationalPrincipalProps {
  header: string;
  content: string;
  layoutMethod:
    | "foundational-principle-container-left"
    | "foundational-principle-container-right";
}

const FoundationalPrincipal: React.FC<FoundationalPrincipalProps> = ({
  header,
  content,
  layoutMethod,
}) => {
  const containerClass =
    layoutMethod === "foundational-principle-container-left"
      ? "foundational-principle-container-left"
      : "foundational-principle-container-right";

  return (
    <div className={containerClass}>
      <div className="foundational-principle-header">{header}</div>
      <div className="foundational-principle-content">{content}</div>
    </div>
  );
};

export const FoundationalPrinciples = () => {
  return (
    <div className="foundational-principles-container">
      <FoundationalPrincipal
        header="Community"
        content="We do this for the kids. Every effort we make is to help them afford the experiences that shape their journeys"
        layoutMethod="foundational-principle-container-left"
      />
      <FoundationalPrincipal
        header="Customer"
        content="We listen. From teams and organizations to supporters and sponsors, every customer plays a vital role in our mission."
        layoutMethod="foundational-principle-container-right"
      />
      <FoundationalPrincipal
        header="Character"
        content="Integrity, compassion, and empathy are at the heart of how we operate. We believe in doing the right thing—always."
        layoutMethod="foundational-principle-container-left"
      />
      <FoundationalPrincipal
        header="Commitment"
        content="We’re all in. We work hard, stay scrappy, and constantly seek ways to improve, ensuring we make the biggest impact possible."
        layoutMethod="foundational-principle-container-right"
      />
      <p className="foundational-principles-extra-content">
        Together, these values drive us to help teams raise the funds they
        need—because every athlete deserves a chance to create lasting memories.
      </p>
    </div>
  );
};

// Meet the Team Component
interface TeamMember {
  image: string;
  name: string;
  role: string;
}

const teamMembers: TeamMember[] = [
  { image: MicheleProfile, name: "Michele Hover", role: "CEO" },
  { image: ShawnProfile, name: "Shawn Hover", role: "CFO" },
  { image: JustinProfile, name: "Justin Hover", role: "Co-Founder" },
  { image: ThaliaProfile, name: "Thalia Hover", role: "Designer" },
  { image: PenelopeProfile, name: "Penelope Hover", role: "Owner in training" },
  {
    image: JeffProfile,
    name: "Jeff Hover",
    role: "Co-Founder and Lead Software Engineer",
  },
  { image: AsaProfile, name: "Asa Holland", role: "Software Engineer" },
  { image: MiaProfile, name: "Mia Markovic", role: "Software Engineer" },
  { image: AlexProfile, name: "Alex Yan", role: "UI Design" },
  { image: TonyProfile, name: "Tony Overpeck ", role: "Head of Sales" },
];

const Profile: React.FC<TeamMember> = ({ image, name, role }) => {
  return (
    <div className="profile-container">
      <img className="profile-image" src={image} alt={name} />
      <div className="profile-content">
        <div className="profile-name">{name}</div>
        <div className="profile-role">{role}</div>
      </div>
    </div>
  );
};

export const MeetOurTeam = () => {
  return (
    <div>
      <p className="meet-our-team-header">Our Team</p>
      <div className="team-container">
        {teamMembers.map((member, index) => (
          <Profile key={index} {...member} />
        ))}
      </div>
    </div>
  );
};
